export default "__VITE_ASSET__D$RLqr88__"